import { Box } from '@mui/material';

import { MouseEvent, useState } from 'react';
import { useAppSelector } from 'store/hooks';
import Card from '../Card';
import NoResults from '../NoResults';
import { OptionMenu } from '../OptionMenu';

const Grid = () => {
  const { businesses, loading } = useAppSelector((state) => state.businesses);
  const [menuElement, setMenuElement] = useState<SVGSVGElement | null>(null);
  const [selectedCompanyId, setSelectedCompanyId] = useState('');

  const handleCloseSettings = () => {
    setMenuElement(null);
    setSelectedCompanyId('');
  };

  const handleOpenSettings = (event: MouseEvent<SVGSVGElement>, id: string) => {
    event.stopPropagation();
    setMenuElement(event.currentTarget);
    setSelectedCompanyId(id);
  };

  if (loading === 'in-progress') return <>Loading...</>;
  if (!businesses.length) return <NoResults />;

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: 'repeat(auto-fill, minmax(270px, 1fr))',
          sm: 'repeat(auto-fill, minmax(320px, 1fr))',
          md: 'repeat(auto-fill, minmax(340px, 1fr))',
          lg: 'repeat(auto-fill, minmax(400px, 1fr))',
          xl: 'repeat(auto-fill, minmax(450px, 1fr))',
        },
        gap: '24px',
        overflowY: 'auto',
        gridAutoRows: 'min-content',
        gridAutoFlow: 'row',
        height: { xs: 'calc(100vh - 190px)', xl: 'calc(100vh - 200px)' },
        alignItems: 'stretch',
      }}
    >
      {businesses &&
        businesses.map((item) => (
          <Card key={item.businessId} data={item} onSettingsClick={handleOpenSettings} />
        ))}
      <OptionMenu
        anchorElement={menuElement}
        onClose={handleCloseSettings}
        id={selectedCompanyId}
      />
    </Box>
  );
};

export default Grid;
